import React from 'react'
import PropTypes from 'prop-types'

const EmptyCell = props => {
  const hours = (timeParts) => {
    return timeParts[0] == '12' ? 0 : parseInt(timeParts[0])
  }

  const extraHours = (timeParts) => {
    const period = timeParts[timeParts.length - 1]

    if (hours(timeParts) < 6 && period == 'AM') {
      return 24
    } else {
      return period == 'PM' ? 12 : 0
    }
  }

  const offset = (timestamp) => {
    const timeParts = timestamp.split(/[\s,:]/)
    const minutes = timeParts.length == 2 ? 0 : 30

    return { hours: hours(timeParts) + extraHours(timeParts), minutes: minutes }
  }

  const onNewEvent = () => {
    const o = offset(props.timestamp)

    props.onNewEvent({
      field: props.fieldId,
      time: moment(props.date).set({ 'hour': o.hours, 'minute': o.minutes }).format(`YYYY-MM-DD HH:mm:SS`)
    })
  }

  return (
    <td
      className={ props.isPeak ? 'cell-rental cell-peak' : 'cell-rental' }
      onClick={onNewEvent}
    >
      <div className='upper'>{ props.isPeak ? 'Primetime' : 'Field' }</div>
      <div className='lower'>Rental</div>
    </td>
  )
}

EmptyCell.propTypes = {
  isPeak: PropTypes.bool,
  date: PropTypes.string.isRequired,
  fieldId: PropTypes.number.isRequired,
  timestamp: PropTypes.string,
  onNewEvent: PropTypes.func.isRequired
}

export default EmptyCell
